export const ANALYTICS_CHECK_DATE_RANGE_LABEL = "Check Date Range";
export const MIN_ANALYTICS_SHARE_PERCENT = 1;
export const MAX_TOP_ANALYTICS_ROWS = 9;
export const ANALYTICS_OTHERS_LABEL = "Others";
